import React, { useState } from 'react';
import { AVATARS } from '../constants';
import FeedbackModal from './FeedbackModal';
import RulebookModal from './RulebookModal';
import SoundModal    from './SoundModal';
import TermsModal    from './TermsModal';
import ContactModal  from './ContactModal';

function SettingsDropdown({ onClose, onFeedback, onRulebook, onSound, onTerms }) {
  const items = [
    { icon: '⭐', label: 'Feedback',          action: onFeedback },
    { icon: '📖', label: 'Rule Book',          action: onRulebook },
    { icon: '🔊', label: 'Sound Settings',     action: onSound    },
    { icon: '📜', label: 'Terms & Conditions', action: onTerms    },
  ];
  return (
    <>
      <div style={{ position: 'fixed', inset: 0, zIndex: 149 }} onClick={onClose} />
      <div className="settings-dropdown">
        {items.map(({ icon, label, action }) => (
          <div key={label} className="settings-item" onClick={() => { action(); onClose(); }}>
            <span style={{ fontSize: '1.2rem' }}>{icon}</span>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </>
  );
}

export default function Navbar({
  profile,
  onHome,
  onRegister,
  onProfile,
  onLogout,
  soundSettings,
  setSoundSettings,
}) {
  const [showSettings,  setShowSettings]  = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [modal, setModal] = useState(null);

  const av = AVATARS.find(a => a.id === profile?.avatarId) || AVATARS[0];

  return (
    <>
      <nav className="navbar">
        {/* Logo */}
        <div onClick={onHome} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img
            src="/logo_rr.jpg"
            alt="Resource Rush"
            style={{ width: '38px', height: '38px', borderRadius: '50%', border: '2px solid #FFD93D', objectFit: 'cover' }}
          />
          <span className="nav-logo" style={{ cursor: 'pointer' }}>Resource Rush</span>
        </div>

        {/* Right side */}
        <div className="nav-right">
          {profile ? (
            /* ── Profile chip + dropdown ── */
            <div style={{ position: 'relative' }}>
              <div
                className="nav-profile-chip"
                onClick={() => setShowProfileMenu(v => !v)}
              >
                <div className="nav-avatar-mini" style={{ background: av.bg }}>
                  {av.emoji}
                </div>
                <span className="profile-name">{profile.username}</span>
                <span style={{ color: '#888', fontSize: '0.7rem', marginLeft: '2px' }}>▾</span>
              </div>

              {/* Profile dropdown */}
              {showProfileMenu && (
                <>
                  <div
                    style={{ position: 'fixed', inset: 0, zIndex: 149 }}
                    onClick={() => setShowProfileMenu(false)}
                  />
                  <div style={{
                    position: 'absolute', top: '44px', right: 0,
                    background: 'var(--bg2)',
                    border: '1px solid var(--border)',
                    borderRadius: '14px',
                    padding: '8px',
                    minWidth: '160px',
                    zIndex: 150,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                  }}>
                    <div
                      className="settings-item"
                      onClick={() => { setShowProfileMenu(false); onProfile(); }}
                    >
                      <span>✏️</span><span>Edit Profile</span>
                    </div>
                    <div
                      className="settings-item"
                      onClick={() => { setShowProfileMenu(false); onLogout(); }}
                      style={{ color: '#FF4060' }}
                    >
                      <span>🚪</span><span>Log Out</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <button className="nav-btn" onClick={onRegister}>👤 Login / Register</button>
          )}

          <button className="nav-btn" onClick={() => setModal('contact')}>📞</button>
          <button className="nav-btn" onClick={() => setShowSettings(v => !v)}>⚙️ Settings</button>
        </div>
      </nav>

      {/* Settings dropdown */}
      {showSettings && (
        <SettingsDropdown
          onClose={() => setShowSettings(false)}
          onFeedback={() => setModal('feedback')}
          onRulebook={() => setModal('rulebook')}
          onSound={()     => setModal('sound')}
          onTerms={()     => setModal('terms')}
        />
      )}

      {/* Modals */}
      {modal === 'feedback' && <FeedbackModal onClose={() => setModal(null)} />}
      {modal === 'rulebook' && <RulebookModal onClose={() => setModal(null)} />}
      {modal === 'sound'    && (
        <SoundModal
          onClose={() => setModal(null)}
          sounds={soundSettings}
          setSounds={setSoundSettings}
        />
      )}
      {modal === 'terms'   && <TermsModal   onClose={() => setModal(null)} />}
      {modal === 'contact' && <ContactModal onClose={() => setModal(null)} />}
    </>
  );
}